import { lazy } from "utils/route";
import React from "react";
import PageLoading from "components/base/PageLoading";

const PublicLayout = lazy(() => import("layouts/PublicLayout"));
const NotFound = lazy(() => import("../../components/base/Errors/NotFound"));
const Login = lazy(() => import("./pages/Login"));
const Register = lazy(() => import("./pages/Register"));
const LoginAs = lazy(() => import("./pages/LoginAs"));
const Fallback = lazy(() => import("./pages/Fallback"));
const ChooseAccount = lazy(() => import("./pages/ChooseAccount"));

export default [
  {
    path: "/login",
    component: PublicLayout,
    suspense: false,
    placeholder: () => <PageLoading loading={true} />,
    routes: [
      {
        path: "/login",
        component: Login,
        exact: true,
        suspense: false,
        placeholder: () => <PageLoading loading={true} />,
      },
    ],
  },
  {
    path: "/register",
    component: PublicLayout,
    suspense: false,
    placeholder: () => <PageLoading loading={true} />,
    routes: [
      {
        path: "/register",
        component: Register,
        exact: true,
        suspense: false,
        placeholder: () => <PageLoading loading={true} />,
      },
    ],
  },
  {
    path: "/login-as",
    component: LoginAs,
    exact: true,
    suspense: false,
    placeholder: () => <PageLoading loading={true} />,
  },
  {
    path: "/sso-fallback",
    component: Fallback,
    exact: true,
    suspense: false,
    placeholder: () => <PageLoading loading={true} />,
  },
  {
    path: "/choose-account",
    component: ChooseAccount,
    exact: true,
    suspense: false,
    placeholder: () => <PageLoading loading={true} />,
  },
];
